<template>
	<div>
		<v-row>
			<v-col cols="12" sm="12" class="d-flex justify-center" v-if="!hideImage">
				<v-img src="/hedef.jpg" height="100%" max-width="500" class="rounded-lg" contain></v-img>
			</v-col>
			<v-col cols="12" sm="12">
				<div class="line-title mt-1">
					<span class="text"> مشاور هوشمند </span>
					<span class="line"></span>
				</div>
				<p class="text-justify grey--text fs-h5" style="">
					کاربر گرامی، «مشاور هوشمند» ما همراه شماست تا در کوتاه‌ترین زمان، بهترین طرح‌های تسهیلاتی متناسب با شرایطتان را پیدا کنید. کافیست اطلاعات خود را در فرم زیر وارد کرده و دکمه «جستجو» را بزنید؛ بقیه مسیر را به ما بسپارید تا مناسب‌ترین گزینه‌ها را پیش رویتان قرار دهیم.
				</p>
				<v-alert type="warning" outlined dense v-if="!ass_requirements.length">
					متاسفانه به دلیل عدم تنظیمات سیستم در حال حاضر این امکان در دسترس نمی باشد.
				</v-alert>
				<div v-else>
					<div class="text-center">
						<v-row class="">
							<v-col cols="12" md="4" v-for="(ass, index) in ass_requirements" :key="ass.id" class="">
								<div>{{ ass.title }}:</div>
								<v-select v-model="assuranceRequirementItemIds[ass.id]" clearable :items="ass.assuranceRequirementItems" item-text="title" item-value="id" dense outlined></v-select>
							</v-col>
						</v-row>
					</div>
					<div class="text-center mt-6">
						<v-btn class="rounded-xl" color="primary" @click="doSearch()" :loading="searchLoading">
							شروع جستجو
						</v-btn>
					</div>
				</div>
			</v-col>
			<!-- Image Section -->

			<!-- Form Section -->
		</v-row>
		<div>
			<v-slide-x-transition :hide-on-leave="true">
				<div v-if="searchSubmitted" class="py-3 px-6">
					<v-alert outlined dense v-if="loans.length == 0" type="error">
						در حال حاضر طرح وام فعالی متناسب با شرایط وجود ندارد.
					</v-alert>
					<div v-else>
						<div class="py-2">طرح های متناسب با شرایط شما:</div>
						<v-row>
							<v-col cols="12" sm="6" md="4" v-for="loan in loans" :key="loan.id">
								<router-link :to="`/cl/plan/${customerCode}/${loan.code}/${loan.title}`" style="text-decoration: none;">
									<plan-grid-item :loan="loan" />
								</router-link>
							</v-col>
						</v-row>
					</div>
				</div>
			</v-slide-x-transition>
		</div>

	</div>
</template>

<script>
	import api from '@/util/app-api'
	import router from '@/router'
	import { call, get } from 'vuex-pathify'
	import toast from '@/util/toast'

	export default {
		name: 'AssuranceRequirementSuggestion',
		components: {
			'plan-grid-item': () => import('@/components/PlanGridItem')
		},
		props: {
			customerCode: { type: Number },
			hideImage: { type: Boolean },
		},
		data: () => ({
			errorMessage: '',
			loans: {},
			submitLoading: false,
			message: '',
			searchSubmitted: false,
			assuranceRequirementItemIds: [],
			ass_requirements: [],
			searchLoading: false,
		}),
		mounted() {
			this.getAssuranceRequirements()
		},
		computed: {
		},
		methods: {
			getAssuranceRequirements() {
				api.get('assuranceRequirement/List/' + this.customerCode, null, { authHeader: false, contentType: 'application/json' })
					.then(res => {
						this.ass_requirements = res
					}).catch(err => {
						toast.error('خطا در دریافت لیست شرایط متقاضی از سرور')
					})
			},
			doSearch() {
				this.searchSubmitted = false
				this.searchLoading = true
				const payload = {}
				for (const key in this.assuranceRequirementItemIds) {
					payload[key] = this.assuranceRequirementItemIds[key] === "" ? null : this.assuranceRequirementItemIds[key]
				}
				api.post('loan/ListByAssuranceRequirement/' + this.customerCode + '/true', payload, { authHeader: false, contentType: 'application/json' })
					.then(
						response => {
							this.loans = response
							this.searchSubmitted = true
						})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(() => {
						this.searchLoading = false
					})
			},
		},
	}
</script>

<style lang="scss"></style>